


















import Component from 'vue-class-component';
import LoginContainer from '@/views/authentication/login-container/LoginContainer.component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { LoginRequest } from '@/models/request/LoginRequest';
import { IS_RECAPTCHA_V2_USED, SEND_FORGOT_PASSWORD_MAIL, SET_AUTH_LOADING_MODE } from '@/types/authentication.types';
import { Prop } from 'vue-property-decorator';
import { RecaptchaNamespace } from '@/globals/recaptcha-namespace.global';

@Component({
  components: {
    LoginContainer
  }
})
export default class ForgotPasswordComponent extends FeedbackComponent {

  @Prop(String) public gov!: string;

  @Action(SEND_FORGOT_PASSWORD_MAIL, StoreNamespace.AUTHENTICATION) public sendForgotPasswordMail;

  @Mutation(SET_AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public setAuthLoadingMode;

  @Getter(IS_RECAPTCHA_V2_USED, StoreNamespace.AUTHENTICATION) public isRecaptchaV2Used!: boolean;

  private forgotPasswordAuth: LoginRequest = {} as LoginRequest;

  public async onLogin(recaptchaV2Response: string): Promise<void> {
    this.setAuthLoadingMode(true);

    this.sendForgotPasswordMail({
      ...(this.isRecaptchaV2Used && { recaptchaV2Response }),
      recaptchaResponse: this.$recaptcha && await this.$recaptcha(RecaptchaNamespace.SEND_FORGOT_PASSWORD),
      userId: Number(this.forgotPasswordAuth.userId),
      indexNum: Number(this.forgotPasswordAuth.indexNum),
    });
  }

}
